import { render, staticRenderFns } from "./GlobalNavigationSection.vue?vue&type=template&id=1e6901cf&scoped=true"
import script from "./GlobalNavigationSection.vue?vue&type=script&lang=ts"
export * from "./GlobalNavigationSection.vue?vue&type=script&lang=ts"
import style0 from "./GlobalNavigationSection.vue?vue&type=style&index=0&id=1e6901cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6901cf",
  null
  
)

export default component.exports